import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import DashboardPage from "./Pages/Dashboard/DashboardPage";
import AddVentePage from "./Pages/Ventes/AddVentes/AddVentePage";
import Layout from "./_Layouts/Layout/Layout";
import SessionsJournaux from "./Pages/SessionJournauxCaisse/SessionJournaux";

import OrganisationPage from "./Pages/Organisations/OrganisationPage";

import LoginPage from "./Pages/Auth/LoginPage";
import ResetPasswordPage from "./Pages/Auth/ResetPasswordPage";
import AutorisationPage from "./Pages/UserAutorisation/AutorisationPage";
import UserRolePage from "./Pages/UserRole/RolePage";
import UserItemPage from "./Pages/Users/UserItemPage";
import LoginLayout from "./_Layouts/Layout/LoginLayout";

import ProductCaracteristiquesPage from "./Pages/Products/ProductCaracteristiques/ProductCaracteristiquesPage";
import ProductCouleursPage from "./Pages/Products/ProductCouleurs/ProductCouleursPage";
import ProductTaillePage from "./Pages/Products/ProductTailles/ProductTaillePage";

import CartePage from "./Pages/Cartes/CartesPage";
import CategoriesPage from "./Pages/Categories/CategoriesPage";

import ProductMarquesPage from "./Pages/Products/ProductMarques/ProductMarquesPage";

import ProductsPage from "./Pages/Products/Products/ProductsPage";

import AchatPage from "./Pages/Achat/AchatPage";
import CaissePage from "./Pages/Caisses/CaissePage";
import OrdersPage from "./Pages/Caisses/OrdersPage";
import TablesPage from "./Components/Caisses/TablesModal";
import ClientPage from "./Pages/Client/ClientPage";
import DepotsPage from "./Pages/Depot/DepotsPage";
import InventairePage from "./Pages/InventairePage/InventairePage";
import Facture from "./Pages/JournalCaisse/Facture";
import HomeCaissePage from "./Pages/JournalCaisse/HomeCaissePage";
import JournauxCaisse from "./Pages/JournalCaisse/JournauxCaisse";
import MouvementsJournal from "./Pages/JournalCaisse/MouvementsJournalPages";
import ArticlePage from "./Pages/Products/Article/ArticlePage";
import FournisseurPage from "./Pages/Products/Fournisseur/FournisseurPage";
import ProductDetailsPage from "./Pages/Products/ProductDetails/ProductDetailsPage";
import ProductTarifPage from "./Pages/Products/ProductTarifs/ProductTarifPage";
import SousCategoriesPage from "./Pages/SousCategories/SousCategoriesPage";
import StockPage from "./Pages/Stock/StockPage";
import TablePage from "./Pages/Table/TablePage";
import {
  changeOrganisationselected,
  SelectedOrganisationId,
  selectIsLoggedIn,
  selectToken,
  selectUserId,
} from "./_App/Redux/Slices/Auth/authSlice";
import {
  closeSessionUserApi,
  findUserByIdApi,
  openSessionUserApi,
} from "./_App/Redux/Slices/users/userSlice";
import { useAppDispatch, useAppSelector } from "./_App/Redux/hooks";
import LayoutCaisse from "./_Layouts/Layout/LayoutCaisse";
import I18nInitializer from "./i18n";

import PinTimeOut from "./Components/Auth/PinTimeOut";
import UnauthorizedPage from "./Pages/Auth/Unauthorized";
import JournalCaisseStat from "./Pages/Statistiques/JournalCaisseStat";

import ReceptionPage from "./Pages/Reception/ReceptionPage";
import Matrice from "./Pages/Products/Matrice/Matrice";
import CommissionPage from "./Pages/Commission/CommissionPage";
import { selectUser } from "./_App/Redux/Slices/Auth/authSlice";
import { User } from "./_App/Types/Entites/User";
import { ToastSuccess } from "./Shared/Toasts/ToastSuccess";
import { ToastWarning } from "./Shared/Toasts/ToastWarning";
import CaisseParametrageForm from "./Components/AppParametrages/Parametrages/CaisseParametrageForm";
import DemandeReception from "./Pages/DemandeReception/DemandeReception";

import BarcodeOnlyCaissePage from "./Pages/Caisses/BarcodeOnlyCaissePage";
import { ListReservations } from "./_App/Redux/Slices/Reservation/ReservationSlice";
import Reservation from "./Pages/Reservation/ReservationPage";
import {
  findParametragesCaisseByOrganisationApi,
  parametrageCaisse,
} from "./_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import { findDepotsDefautByOrganisationApi } from "./_App/Redux/Slices/depot/depotSlice";
import PageListDemande from "./Pages/Transfert/PageListDemande";
import PageDemandeTransfert from "./Pages/Transfert/PageDemandeTransfert";
import GratuitePage from "./Pages/Caisses/Remise/GratuitePage";
import FidelitePage from "./Pages/Client/FidelitePage";
import RemisePage from "./Pages/Caisses/Remise/RemisePage";
import Distribution from "./Components/TransfertArticles/Distribution/Distribution";
import DistributionParMagasin from "./Components/TransfertArticles/Distribution/DistributionParMagasin";
import Mouvement from "./Components/Mouvement/Mouvement";
import Mouvementcaisse from "./Components/Mouvement/Mouvementcaisse";
import ChequesPage from "./Pages/Caisses/ChequesPage";
import ReptureStock from "./Pages/Caisses/ReptureStockPage";
import Mouvementpaiement from "./Components/Mouvement/Mouvementpaiement";
import ServerError from "./Pages/ServerError";
import LoadingPage from "./Pages/LoadingPage";
import Loader from "./_Layouts/Loader/Loader";
import PaidOrder from "./_Layouts/RightBar/RightBar/order/PaidOrder";
import Rapport from "./Pages/Rapport/Rapport";
import RapportClientPage from "./Pages/Rapport/RapportClientPage";
import FactureSansEspeces from "./Pages/JournalCaisse/FactureSansEspeces";
import Verificationdemande from "./Pages/DemandeRemise/Verificationdemande";
import DemandeRemise from "./Pages/DemandeRemise/DemandeRemise";
import ArticleDefectueuxPage from "./Pages/ArticleDefectueux/ArticleDefectueuxPage";
import RetourEchangeConfirmationPage from "./Pages/RetourEchangeConfirmationPage";
import Pagevide from "./Pages/DemandeRemise/pagevide";
import NonVendu from "./Pages/NonVendu/NonVendu";
import AnnulerOrder from "./Pages/Caisses/AnnulerOrder";
import Swal from "sweetalert2";
import DemandeRemiseTransction from "./Pages/DemandeRemise/DemandeRemiseTransction";
import VentesPage from "./Pages/Caisses/VentesPage";
import { error } from "console";
import DemandeReservation from "./Pages/Caisses/DemandeReservation";
import MouvementVente from "./Components/Mouvement/MouvementVente";
import ValorisationStockPage from "./Pages/Stock/ValorisationStockPage";
import LayoutProductsCaisse from "./_Layouts/Layout/LayoutProductsCaisse";
import DistributionSociete from "./Components/TransfertArticles/Distribution/DistributionSociete";
import IncidentPage from "./Pages/Incident/IncidentPage";
import DistributionParDepot from "./Components/TransfertArticles/Distribution/DistributionParDepot";
import SouchesPage from "./Pages/Souches/SouchesPage";
import RemiseList from "./Components/Remises/RemiseV2/RemiseList";
import RemiseV2Page from "./Pages/Caisses/Remise/RemiseV2/RemiseV2Page";
import ReglementsPage from "./Pages/Client/ReglementsPage";
import DistributionArticle from "./Pages/DistributionArticle/DistributionArticle";
import { getAddressByMacApi } from "./_App/Redux/Slices/userMacAdress/userAddressMacSlice";
import MacAddressComponent from "./Components/UserMacAdress/AddMacForm";
import styled from "styled-components";
import ListRemiseV2Page from "./Pages/Caisses/Remise/RemiseV2/ListRemiseV2Page";
import ConditionRemise from "./Pages/Caisses/Remise/RemiseV2/ConditionRemise";
import ArticleMovementSummary from "./Components/Mouvement/RapportAchatVente";

import { io } from "socket.io-client";
const CustomModalBody = styled(Modal.Body)`
  p {
    margin: 5px 0;
    color: #333;
  }s
`;

let socket: any = undefined;

function App() {

  /**
   * axios config
   */


  const TOKEN = useAppSelector(selectToken);
  const isLoggedIn = useAppSelector(selectIsLoggedIn);
  const userId = useAppSelector(selectUserId);
  axios.defaults.baseURL = process.env.REACT_APP_API_URL;
  // axios.defaults.headers.Authorization = `${localStorage.getItem(process.env.REACT_APP_TOKEN_NAME as string)}`
  axios.defaults.headers.Authorization = `${TOKEN}`;
  const dispatch = useAppDispatch();
  const [showPinModal, setShowPinModal] = useState(false);
  const currentOrganisation = useAppSelector(SelectedOrganisationId);

  const [isOnline, setIsOnline] = useState<boolean | null>(null);

  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const [loading, setloading] = useState(false);

  // Socket + synchro
  /*
useEffect(() => {
  let socketInstance:any;

  if (isLoggedIn) {
    // 1. On crée la connexion
    socketInstance = io("https://api.bendou.scaniny.com");

    // 2. On attache l'écouteur IMMEDIATEMENT au socketInstance
    socketInstance.on("connection-restored", (data:any) => {
      if (data.status === "Local") {
        Swal.fire(data.message);
      } else {
        Swal.fire({
          text: "Connexion disponible. Synchroniser ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Oui, synchroniser",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const response = await axios.post(`syncDatabase`);
            response.status === 200 ? ToastSuccess(response.data.message) : ToastWarning(response.data.message);
          }
        });
      }
    });
  }

  // 3. LE NETTOYAGE TOTAL (Indispensable pour ton erreur 10054)
  return () => {
    if (socketInstance) {
      console.log("Nettoyage : suppression des écouteurs et déconnexion");
      socketInstance.off("connection-restored"); // On retire l'écouteur
      socketInstance.disconnect(); // On ferme le socket sur le serveur
    }
  };
}, [isLoggedIn]); */
 /* useEffect(() => {
    if (socket) {
      socket.on("connection-restored", (data: any) => {
        console.log("socket", data);
        if (data.status === "Local") {
          Swal.fire(data.message);
        } else {
          Swal.fire({
            text: "Vous êtes connecté localement. Une connexion est disponible. Vous pouvez vous connecter au serveur pour synchroniser, mais cela prendra du temps",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Oui, effectuer la synchronisation.",
          }).then(async (result) => {
            if (result.isConfirmed) {
              // call synchro
              const response = await axios.post(`syncDatabase`);
              if ((response.status = 200)) {
                ToastSuccess(response.data.message);
              } else {
                ToastWarning(response.data.message);
              }
            }
          });

          return () => {
            socket.off("connection-restored");
          };
        }
      });
    }
  }, [socket]);
*/
  ///////
  useEffect(() => {
    axios.interceptors.request.use((config) => {
      const EXCLUDE_URLS = [
        "stock/findStockByArticleAndDepots/",
        "article/findArticleByBarCode/",
        "client/findClientByBarcode/",
        "user/findUserByCodeApi/",
        "article/findArticleStockByBarCodeApi",
        "souscategorie/findSousCategorieBySocieteApi",
        "remises/remiseCheck",
        "remises/fideliteCheck",
        "remises/gratuiteCheck",
        "user/findUsersApi",
        "depots/findDepotsByOrganisationsApi",
        "inventaire/CalculStockInventaireArticleApi",
        "inventaire/CalculStockInventaireApi/",
        "client/findClientHistorique/",
        "orders/findOrdersByOrganisation",
        "client/findDefaultClientsBySociete",
        "article/findArticlebyParentCode",
        "souscategorie/findSousCategorieLikeLibelleApi",
        "articledefectueux/findArticleDefectueuxBarCode",
        "user/findUserByOrganisationAp",
        "article/findArticleRefParentApi",
        "user/findvendeurs",
        "ticket/findTicketsByOrderApi",
        "parametragesmenu/findParametragesMenusApi",
        "article/findArticleStockByRefApi",
        "produit/findproductfournisseurApi",
        "article/findArticlebysocieteApi",
        "article/findArticleByBarCode",
        "produit/findProduitParArticleApi",
        "depots/findDepotsByCodeApi",
        "organisation/findOrganisationByCodeApi",
        "organisation/allOrganisationsApi",
        "article/findArticleParentCode",
        "stock/findStockByArticle_codeApi",
      ];

      const shouldSetLoading = !EXCLUDE_URLS.some((urlPart) =>
        config?.url?.includes(urlPart),
      );

      if (shouldSetLoading) {
        setloading(true); // Show loader
      }
      return config;
    });

    axios.interceptors.response.use(
      (response) => {
        setloading(false); // Hide loader
        return response;
      },
      (error) => {
        setloading(false); // Hide loader
        /*if (error && error?.response?.status === 401) {
          document.body.innerHTML = `
          <div style="display: flex; justify-content: center; align-items: center; height: 100vh; background-color: #FFFFFF; color: #333; font-family: Arial, sans-serif; text-align: center;">
              <div>
                  <h1>401 - Unauthorized</h1>
                  <p>You are not authorized to view this page.</p>
              </div>
          </div>
      `;
        }*/
        /*  if (error.response && error.response.status === 500) {
          window.location.href = "/serverError";
        }
        if (error.code === "ERR_NETWORK") {
          window.location.href = "/serverError";
        }*/
        return Promise.reject(error);
      },
    );
  }, [dispatch]);
  useEffect(() => {
    const checkUserOnlineStatus = async () => {
      try {
        if (userId) {
          const action = await dispatch(findUserByIdApi(userId));

          if (findUserByIdApi.fulfilled.match(action)) {
            const user = action.payload;
            setCurrentUser(user);

            if (user && user.online !== undefined) {
              setIsOnline(user.online);
            }
          } else {
            console.error(
              "Erreur lors de la récupération des informations de l'utilisateur :",
              action.payload,
            );
          }
        }
      } catch (error) {
        console.error(
          "Erreur lors de la vérification du statut en ligne de l'utilisateur :",
          error,
        );
      }
    };

    checkUserOnlineStatus();
  }, [userId]);

  useEffect(() => {
    if (currentOrganisation) {
      dispatch(findParametragesCaisseByOrganisationApi(currentOrganisation));
      dispatch(findDepotsDefautByOrganisationApi(currentOrganisation));
    }
  }, [currentOrganisation]);

  useEffect(() => {
    if (isOnline === false && isLoggedIn !== false) {
      setShowPinModal(true);
    }
  }, [isOnline, isLoggedIn]);
  // Références pour les valeurs dynamiques
  const isOnlineRef = useRef(isOnline);
  const userIdRef = useRef(userId);
  useEffect(() => {
    let idleTimer: NodeJS.Timeout;

    isOnlineRef.current = isOnline;
    userIdRef.current = userId;

    const resetIdleTimer = () => {
      clearTimeout(idleTimer);
      if (isOnlineRef.current) {
        idleTimer = setTimeout(handleOnIdle, 300000); // 5 min
      }
    };

    const handleOnIdle = () => {
      const currentUserId = userIdRef.current;
      if (currentUserId) {
        dispatch(closeSessionUserApi(currentUserId)).then((response) => {
          if (response.payload?.success) {
            const user = response.payload.data;
            setIsOnline(user.online);
          }
        });
      }
      resetIdleTimer();
    };

    resetIdleTimer();

    const events = [
      "mousemove",
      "keydown",
      "mousedown",
      "click",
      "scroll",
      "touchstart",
    ];

    events.forEach((event) => window.addEventListener(event, resetIdleTimer));

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, resetIdleTimer),
      );
      clearTimeout(idleTimer);
    };
  }, []); // 👈 Exécuter seulement une fois au montage

  const handlePinModalComplete = (pinValue: string) => {
    if (userId) {
      dispatch(openSessionUserApi({ userId, pin: pinValue })).then(
        (response) => {
          if (response.payload?.success) {
            setShowPinModal(false);
            setIsOnline(true);
          } else {
            ToastWarning("Pin invalide");
          }
        },
      );
    }
  };

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        isOnline === false &&
        isLoggedIn !== false && (
          <Modal show={showPinModal} centered>
            <Modal.Header>
              <div className="header-message">
                Merci de saisir votre code PIN pour reconnecter{" "}
              </div>
            </Modal.Header>
            <Modal.Body>
              <Row className="text-center mt-2">
                <Col className="mb-2">
                  <PinTimeOut
                    onComplete={handlePinModalComplete}
                    userId={userId!}
                  />
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        )
      )}
      <div></div>
      <BrowserRouter>
        <I18nInitializer />

        <Routes>
          <Route path="/serverError" element={<ServerError />} />
          <Route
            path="/confirmation/:societe/:id"
            element={<RetourEchangeConfirmationPage />}
          />

          {isLoggedIn !== false ? (
            <Route path="/" element={<Layout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/ventes/:type" element={<AddVentePage />} />
              <Route path="/ventes/:type/:id" element={<AddVentePage />} />
              <Route path="/cheques" element={<ChequesPage />} />
              <Route path="/rupture" element={<ReptureStock />} />
              <Route path="/rapport" element={<Rapport />} />
              <Route path="/rapportclient" element={<RapportClientPage />} />
              <Route
                path="/articledefectueux"
                element={<ArticleDefectueuxPage />}
              />
              <Route
                path="/admin_validation/:orderid"
                element={<Verificationdemande />}
              />
              <Route path="/users" element={<UserItemPage />} />
              <Route path="/roles" element={<UserRolePage />} />
              <Route path="/autorisations" element={<AutorisationPage />} />
              <Route path="/organisations" element={<OrganisationPage />} />
              <Route path="/depots" element={<DepotsPage />} />
              <Route path="/HomeCaisse" element={<HomeCaissePage />} />
              <Route
                path="/sessionsJournauxStat"
                element={<SessionsJournaux />}
              />

              <Route path="/cartes" element={<CartePage />} />
              <Route
                path="/cartes/categories/:idcarte"
                element={<CategoriesPage />}
              />

              <Route
                path="/categories/souscategories/:idcategorie"
                element={<SousCategoriesPage />}
              />
              <Route path="/categories" element={<CategoriesPage />} />

              <Route path="/souscategories" element={<SousCategoriesPage />} />
              <Route
                path="/caracteristique"
                element={<ProductCaracteristiquesPage />}
              />
              <Route path="/tailles" element={<ProductTaillePage />} />
              <Route path="/couleurs" element={<ProductCouleursPage />} />
              <Route path="/marques" element={<ProductMarquesPage />} />
              <Route path="/product" element={<ProductsPage />} />
              <Route path="/productdetails" element={<ProductDetailsPage />} />
              <Route path="/producttarifs" element={<ProductTarifPage />} />
              <Route path="/fournisseurs" element={<FournisseurPage />} />
              <Route path="/achat" element={<AchatPage />} />
              <Route path="/reception" element={<ReceptionPage />} />
              <Route path="/distribution" element={<Distribution />} />
              <Route
                path="/distributionArticle/*"
                element={<DistributionArticle />}
              />

              <Route
                path="/DistributionParMagasin"
                element={<DistributionParMagasin />}
              />
              <Route
                path="/DistributionParDepots"
                element={<DistributionParDepot />}
              />
              <Route
                path="/DistributionParSociete"
                element={<DistributionSociete />}
              />

              <Route path="/matrice" element={<Matrice />} />
              <Route path="/commission" element={<CommissionPage />} />
              <Route path="/demandeR" element={<DemandeReception />} />

              <Route path="/inventaire" element={<InventairePage />} />
              <Route path="/article" element={<ArticlePage />} />
              <Route path="/stock" element={<StockPage />} />
              <Route path="/souche" element={<SouchesPage />} />

              <Route
                path="/Valorisationstock"
                element={<ValorisationStockPage />}
              />

              <Route path="/mouvement" element={<Mouvement />} />
              <Route path="/mouvementArticle" element={<MouvementVente />} />
              <Route path="/achatVente" element={<ArticleMovementSummary />} />

              <Route path="/nonvendu" element={<NonVendu />} />
              <Route
                path="/mouvementpaiement"
                element={<Mouvementpaiement />}
              />
              <Route path="/incident" element={<IncidentPage />} />
              <Route path="/incident/:numIncident" element={<IncidentPage />} />

              <Route path="/mouvementvente" element={<Mouvementcaisse />} />

              <Route path="/unauthorized" element={<UnauthorizedPage />} />

              <Route
                path="/mouvementcaisse/:id"
                element={<MouvementsJournal />}
              />
              <Route path="/facture/:id" element={<Facture />} />
              <Route
                path="/factureSansEspeces/:id"
                element={<FactureSansEspeces />}
              />
              <Route
                path="/avance/:orderid"
                element={<DemandeReservation />}
              ></Route>
              <Route path="/journauxcaisse" element={<JournauxCaisse />} />
              <Route path="/article" element={<ArticlePage />} />
              <Route path="/client" element={<ClientPage />} />
              <Route path="/reglements" element={<ReglementsPage />} />

              <Route path="/fidelite" element={<FidelitePage />} />
              <Route path="/remise" element={<RemisePage />} />
              <Route path="/remisefiltre" element={<RemiseV2Page />} />
              <Route path="/Listremisefiltre" element={<ListRemiseV2Page />} />
              <Route
                path="/ConditionRemise/:id"
                element={<ConditionRemise />}
              />

              <Route path="/gratuite" element={<GratuitePage />} />
              <Route path="/commandes" element={<OrdersPage />}></Route>
              <Route path="/ventes" element={<VentesPage />}></Route>

              <Route path="/PaidOrder/:OrderId" element={<PaidOrder />}></Route>

              <Route path="/table" element={<TablePage />} />
              <Route path="/reservation" element={<Reservation />} />
              <Route
                path="/DemandeRemises"
                element={<DemandeRemiseTransction />}
              />
            </Route>
          ) : (
            <>
              <Route path="/clickok" element={<Pagevide />}></Route>
              <Route
                path="/annulerOrder/:orderid"
                element={<AnnulerOrder />}
              ></Route>
              <Route
                path="/avance/:orderid"
                element={<DemandeReservation />}
              ></Route>
              <Route
                path="/validation/:orderid"
                element={<Verificationdemande />}
              />
            </>
          )}

          {isLoggedIn !== false ? (
            <Route path="/" element={<LayoutCaisse />}>
              <Route path="/caisse" element={<CaissePage />}></Route>
              <Route path="/caisse/:orderId" element={<CaissePage />}></Route>

              <Route path="/test" element={<BarcodeOnlyCaissePage />} />
              <Route
                path="/caisse/:tableId/:table"
                element={<CaissePage />}
              ></Route>

              <Route path="/tables" element={<TablesPage />}></Route>
            </Route>
          ) : (
            <Route path="*" element={<Navigate to="/login" />} />
          )}

          <Route path="/login" element={<LoginLayout />}>
            <Route path="/login" element={<LoginPage />} />
          </Route>
          <Route
            path="/reset-password/:token"
            element={<ResetPasswordPage />}
          />
          <Route path="/Demande" element={<DemandeRemise />}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
